import React from 'react';
import { connect } from 'react-redux';

import {
  changeText,
} from '../actions/textbox-element-actions';

import styles from '../../../../stylesheet/css/header-builder/textbox-element-options.css';

export const TextBoxElementOptions = ({
  onTextChange,
  options = {}
}) => {
  const { text } = options;

  const handleTextChange = e => onTextChange(e.target.value);

  return (
    <div>
      <header>Text:</header>
      <textarea
        rows="5"
        autoFocus={true}
        className={styles.text}
        value={text}
        onChange={handleTextChange}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onTextChange(value) {
      dispatch(changeText({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(TextBoxElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/TextBoxElementOptions.js